import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Globe, ChevronDown } from 'lucide-react';
import { selectorOptions } from '@/lib/locales';

// Links only — never redirects automatically.
export default function CountrySelector({ variant = 'header', onNavigate }) {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const options = selectorOptions();
  const seg = pathname.split('/')[1];
  const current = options.find((o) => o.cc && o.cc === seg) || options[0];

  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);

  if (variant !== 'header') {
    return (
      <nav aria-label="Country and language" className={variant === 'mobile' ? 'flex flex-wrap justify-center gap-4' : 'flex flex-wrap items-center gap-x-4 gap-y-2'}>
        {options.map((o) => (
          <Link key={o.label} to={o.to} onClick={onNavigate}
            className={`${variant === 'mobile' ? 'text-sm' : 'text-[10px]'} font-inter font-medium tracking-[0.15em] uppercase transition-colors ${o === current ? 'text-primary' : 'text-muted-foreground hover:text-primary'}`}>
            {o.label}
          </Link>
        ))}
      </nav>
    );
  }

  return (
    <div ref={ref} className="relative">
      <button type="button" onClick={() => setOpen(!open)} onMouseEnter={() => { import('@/pages/locale/LocaleHub'); }} aria-expanded={open} aria-haspopup="true" aria-label="Select country"
        className="text-muted-foreground text-sm font-medium tracking-wider uppercase hover:text-primary transition-colors flex items-center gap-1.5">
        <Globe className="w-4 h-4" />
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-3 w-48 rounded-xl border border-border/50 bg-background/95 backdrop-blur-xl p-2 shadow-lg">
          {options.map((o) => (
            <Link key={o.label} to={o.to} onClick={() => setOpen(false)}
              className={`block px-3 py-2 rounded-lg text-xs font-inter font-medium tracking-wider uppercase transition-colors ${o === current ? 'text-primary' : 'text-muted-foreground hover:text-primary hover:bg-secondary/40'}`}>
              {o.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}